import React from 'react';
import Footer from '../components/Footer';

const Contact = () => {
  return <Footer />;
};

export default Contact;
